import React from 'react';

function AllJobs() {
  return <div>All Jobs page is under development...</div>;
}

export default AllJobs;
